<template>
    <div class="app-header">
        <header class="header d-flex aligh-center">
            <router-link to="/" class="header__brand"></router-link>

            <nav class="header__nav flex-grow-1">
                <ul class="nav d-flex">
                    <li
                        v-for="nav in navList"
                        :key="nav.label"
                        class="nav__item"
                        :class="{ 'nav__item--active': navActiveRouteName === nav.routeName }"
                        @click="returnTop"
                    >
                        <span @click="handleRouter(nav)">{{ nav.label }}</span>
                        <i class="nav__indicator"></i>
                        <ul v-if="nav.children" class="nav-child-container">
                            <li
                                v-for="(child, childIndex) in nav.children"
                                :key="child + childIndex"
                                class="nav-child"
                                :class="{
                                    'nav-child--selected':
                                        selectedURlLink === child.urlLink && navActiveRouteName === nav.routeName
                                }"
                                @click="handleNav(nav, child)"
                            >
                                {{ child.label }}
                            </li>
                        </ul>
                    </li>
                    <li class="nav__item">
                        <span @click="handleNavigate('official')">指令集官网</span>
                    </li>
                    <li class="nav__item">
                        <span @click="handleNavigate('community')">开发者社区</span>
                    </li>
                </ul>
            </nav>

            <div class="header__actions d-flex align-center">
                <div v-show="showSearch" class="search">
                    <isc-input
                        v-model="keywords"
                        suffix-icon-click
                        placeholder="找文章/找答案"
                        suffix-icon="isc-icon-search"
                        @keyup.enter.native="onSearch"
                        @icon-click="onSearch"
                    ></isc-input>
                </div>

                <!-- <div class="user">
                    <div v-if="login">
                        <isc-dropdown trigger="click" class="user__dropdown" @command="onCommand">
                            <isc-badge is-dot class="user__badge" :hidden="hidden">
                                <img :src="img" alt="头像" class="user__avatar" />
                            </isc-badge>

                            <isc-dropdown-menu slot="dropdown" class="user__menu">
                                <isc-dropdown-item v-for="(menu, index) in menuList" :key="index" :command="menu">
                                    <isc-badge v-if="menu.label === '系统消息'" is-dot :hidden="hidden" class="item"
                                        >系统消息</isc-badge
                                    >
                                    <span v-else>{{ menu.label }}</span>
                                </isc-dropdown-item>
                            </isc-dropdown-menu>
                        </isc-dropdown>
                    </div>
                    <router-link v-else class="user__login" :to="{ name: '登录' }">登录</router-link>
                </div> -->
            </div>
        </header>
    </div>
</template>

<script>
import { logout, notifiy } from '../../../service/user';

export default {
    name: 'AppHeader',

    data() {
        return {
            navList: [
                // {
                //     routeLink: 'article',
                //     routeName: '文章',
                //     label: '文章',
                //     urlLink: 'all',
                //     children: [
                //         { label: '系统开发', urlLink: 'systemDevelopment' },
                //         { label: '数据工具', urlLink: 'dataTools' },
                //         { label: '设备集成', urlLink: 'equipmentIntegration' },
                //         { label: '活动沙龙', urlLink: 'activitySalon' }
                //     ]
                // },
                // {
                //     routeLink: 'issue',
                //     routeName: '问答',
                //     label: '问答',
                //     urlLink: 'all',
                //     children: [
                //         { label: '系统开发', urlLink: 'systemDevelopment' },
                //         { label: '数据工具', urlLink: 'dataTools' },
                //         { label: '设备集成', urlLink: 'equipmentIntegration' }
                //     ]
                // },
                {
                    routeLink: 'document',
                    routeName: '文档',
                    label: '文档中心'
                },
                // { routeLink: 'download', routeName: '下载', label: '下载' },
                // { routeLink: '/developer/#/', routeName: '开源组件', label: '开源组件' }
            ],
            menuList: [
                { label: '账户认证', path: 'accountAuth' },
                { label: '系统消息', path: 'systemMessage' },
                { label: '我的文章', path: 'myArticle' },
                { label: '我的问题', path: 'myQuestion' },
                { label: '安全设置', path: 'accountSecurity' },
                { label: '账号退出' }
            ],

            keywords: '',
            hidden: true,
            img: ''
        };
    },

    computed: {
        selectedURlLink: {
            get() {
                return this.$route.query.tab || '';
            },
            set() {}
        },

        navActiveRouteName() {
            const lastName = this.$route.name;

            if (/文章/.test(lastName)) return '文章';
            if (/问答/.test(lastName)) return '问答';
            if (/文档/.test(lastName)) return '文档';
            if (/下载/.test(lastName)) return '下载';

            return '';
        },

        showSearch() {
            const { matched = [] } = this.$route;
            const showHeaderSearch = matched.find((route) => {
                const { meta = {} } = route;
                const { showHeaderSearch = false } = meta;

                if (showHeaderSearch) return true;
            });

            return !!showHeaderSearch;
        },

        login() {
            return !!this.$store.state.user.userInfo.token;
        },

        Inputshow() {
            return this.$route.path;
        }
    },

    watch: {
        '$store.state.user.userInfo': {
            async handler(value) {
                if (value.token) {
                    this.img = value.avatar;
                    const res = await notifiy();
                    this.$store.commit('user/SET_NOTIFIY', res);
                    if (res > 0) {
                        this.hidden = false;
                    } else {
                        this.hidden = true;
                    }
                } else {
                    this.img = null;
                }
            },
            deep: true,
            immediate: true
        },
        '$store.state.user.notifiy': {
            handler(value) {
                if (value > 0) {
                    this.hidden = false;
                } else {
                    this.hidden = true;
                }
            },
            deep: true,
            immediate: true
        }
    },

    created() {
        if (this.$route.query.keywords) {
            this.keywords = this.$route.query.keywords;
        }
    },

    methods: {
        returnTop() {
            document.getElementsByTagName('html')[0].scrollTop = 0;
        },

        handleRouter(nav) {
            if (nav.routeName === '开源组件') {
                window.open('/developer/');
                return;
            }
            this.selectedURlLink = '';
            if (nav.children) {
                this.$router.push({ name: nav.routeName });
            } else {
                this.$router.push({ name: nav.routeName });
            }
        },

        handleNav(nav, child) {
            this.$router.push({ path: `/${nav.routeLink}?tab=${child.urlLink}` });
        },

        onSearch() {
            this.$router.push({ name: '搜索', query: { keywords: this.keywords } });
        },

        onCommand(item) {
            if (item.label === '账号退出') {
                this.$store.dispatch('user/signOut');
                this.$router.push({ name: '登录', query: { from: this.$route.fullPath } });
            } else {
                this.$router.push({ name: '用户中心', query: { tab: item.path } });
            }
        },
        handleNavigate(type) {
            if (type === 'community') {
                window.open('https://open.isyscore.com');
            } 
            else if (type === 'official') {
                window.open('https://www.isyscore.com');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.app-header {
    background: #2d2d2d;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 9;
}

.header {
    width: 1200px;
    height: 60px;
    margin-left: auto;
    margin-right: auto;

    &__brand {
        background: url('../../../assets/imgs/logo.svg') center center no-repeat;
        width: 100px;
        height: 30px;
        background-size: 100%;
        flex-shrink: 0;
    }

    &__nav {
        margin-left: 30px;
    }
}

.nav {
    &__item {
        position: relative;

        &:hover {
            .nav-child-container {
                display: block;
                transition: 0.3s;
            }
        }
    }

    &__item--active &__indicator {
        display: block;
    }

    &__indicator {
        display: none;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 30px;

        &::before,
        &::after {
            content: '';
            position: absolute;
            right: 0;
            bottom: 10px;
            height: 2px;
            width: 50%;
        }

        &::before {
            left: 0;
            background: #00b2f8;
        }

        &::after {
            right: 0;
            background: #047aff;
        }
    }

    span {
        display: block;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        letter-spacing: 1px;
        padding-left: 20px;
        padding-right: 20px;
        cursor: pointer;
        margin: 10px 0;
        height: 30px;
        line-height: 30px;
    }
}

.nav-child-container {
    display: none;
    width: 108px;
    position: absolute;
    top: 50px;
    left: -20px;
    text-align: center;
    padding: 4px 0;
    background: #2d2d2d;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 1px;

    .nav-child {
        height: 25px;
        line-height: 25px;

        &:not(:last-child) {
            margin-bottom: 8px;
        }

        &:hover {
            cursor: pointer;
            font-weight: 600;
            color: #62a7ff;
        }

        &--selected {
            font-weight: 600;
            color: #62a7ff;
        }
    }
}

.search {
    ::v-deep {
        .isc-input {
            width: 240px;
        }

        .isc-input__inner {
            background-color: #2d2d2d;
            border: 1px solid #999;
            border-radius: 2px;
            color: #bbb;

            &:focus {
                border-color: #999999;
                box-shadow: none;
            }

            &:hover {
                border-color: #999999;
            }
        }
    }
}

.user {
    margin-left: 30px;

    &__avatar {
        width: 30px;
        height: 30px;
    }

    &__menu {
        background-color: #222;
        border: none;
        padding: 10px 0;

        ::v-deep {
            .isc-dropdown-menu__item {
                color: #ffffff;
                text-align: center;
                font-size: 14px;

                &:hover {
                    background-color: #1a1a1a;
                }
            }
        }
    }

    &__login {
        color: #fff;
    }
}
</style>
